import { render } from "./RoundStatus.vue?vue&type=template&id=c2492424&scoped=true"
import script from "./RoundStatus.vue?vue&type=script&lang=js"
export * from "./RoundStatus.vue?vue&type=script&lang=js"

import "./RoundStatus.vue?vue&type=style&index=0&id=c2492424&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c2492424"

export default script